"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>useGetSurveyContent
});
const external_react_namespaceObject = require("react");
const fetchWithTimeout_js_namespaceObject = require("../utils/fetchWithTimeout.js");
var fetchWithTimeout_js_default = /*#__PURE__*/ __webpack_require__.n(fetchWithTimeout_js_namespaceObject);
const analytics_js_namespaceObject = require("../analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const useGetSurveyContent_useGetSurveyContent = (submitChatMessagesPayload)=>{
    const [encodedId, setEncodedId] = (0, external_react_namespaceObject.useState)('');
    const [details, setDetails] = (0, external_react_namespaceObject.useState)(null);
    const [loading, setLoading] = (0, external_react_namespaceObject.useState)(true);
    const [isDetailsRetrieved, setIsDetailsRetrieved] = (0, external_react_namespaceObject.useState)(false);
    const { hotelPayload, carPayload, flightPayload, packagePayload } = submitChatMessagesPayload;
    const mergedPayload = {
        ...hotelPayload,
        ...carPayload,
        ...flightPayload,
        ...packagePayload
    };
    (0, external_react_namespaceObject.useEffect)(()=>{
        const fetchLink = async (offerNumber)=>{
            const url = `/genai-svc/genai/survey/details/${offerNumber}`;
            const response = await fetchWithTimeout_js_default()(url, {
                method: 'GET'
            });
            if (response.ok) {
                const result = await response.json();
                setDetails(result?.details ?? []);
                setEncodedId(result?.encodedId ?? '');
                setIsDetailsRetrieved(result?.isDetailsRetrieved ?? false);
            }
            setLoading(false);
        };
        const offerNumber = mergedPayload?.offerNumber;
        if (offerNumber) fetchLink(offerNumber).catch((e)=>analytics_js_default().log({
                message: e.message,
                source: 'useGetSurveyLink'
            }));
    }, []);
    return {
        details,
        encodedId,
        isDetailsRetrieved,
        loading
    };
};
const useGetSurveyContent = useGetSurveyContent_useGetSurveyContent;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
